export default function PricingTransparency() {
  return (
    <section className="py-28 px-5 md:px-[75px]" style={{ background: 'linear-gradient(135deg, #1a3870 0%, #061e45 100%)' }}>
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-end mb-20">
          <div>
            <p
              className="text-[#d3b366] text-[10px] uppercase tracking-[0.25em] font-medium mb-5"
              style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
            >
              Pricing
            </p>
            <h2
              className="text-white text-4xl md:text-5xl lg:text-[54px] font-light leading-[1.1]"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              No Hidden Fees.
              <br />
              <em className="not-italic text-[#d3b366]">No Surprises.</em>
            </h2>
          </div>
          <blockquote className="border-l-2 border-[#d3b366] pl-6 md:pl-8">
            <p
              className="text-white/60 text-[15px] md:text-[17px] lg:text-[19px] leading-relaxed"
              style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
            >
              Most processors bury their margin in interchange-plus markups, monthly minimums, and vague "service fees." We itemize every dollar so you know exactly what you are paying — and why.
            </p>
          </blockquote>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 mb-20">
          {/* Interchange */}
          <div className="bg-transparent p-10">
            <div className="w-12 h-12 flex items-center justify-center bg-[#d3b366]/10 rounded-lg mb-6">
              <i className="ri-exchange-dollar-line text-[#d3b366] text-2xl" />
            </div>
            <h3
              className="text-white text-xl font-medium mb-3"
              style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
            >
              Interchange Pass-Through
            </h3>
            <p
              className="text-white/50 text-[15px] leading-relaxed mb-6"
              style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
            >
              You pay the exact interchange rate set by card networks — Visa, Mastercard, Amex. No padding. No hidden margins. Just the exact rate set by the card networks.
            </p>
            <div className="border-t border-white/10 pt-6">
              <p
                className="text-[#d3b366] text-3xl font-light mb-1"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                0%
              </p>
              <p
                className="text-white/35 text-[10px] uppercase tracking-[0.15em]"
                style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
              >
                Markup on Interchange
              </p>
            </div>
          </div>

          {/* Processing */}
          <div className="bg-transparent p-10">
            <div className="w-12 h-12 flex items-center justify-center bg-[#d3b366]/10 rounded-lg mb-6">
              <i className="ri-percent-line text-[#d3b366] text-2xl" />
            </div>
            <h3
              className="text-white text-xl font-medium mb-3"
              style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
            >
              Transparent Processing Fee
            </h3>
            <p
              className="text-white/50 text-[15px] leading-relaxed mb-6"
              style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
            >
              One clear processing fee per transaction. No monthly minimums, no statement fees, no PCI compliance charges, no "customer service" surcharges.
            </p>
            <div className="border-t border-white/10 pt-6">
              <p
                className="text-[#d3b366] text-3xl font-light mb-1"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                1 Fee
              </p>
              <p
                className="text-white/35 text-[10px] uppercase tracking-[0.15em]"
                style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
              >
                Per Transaction
              </p>
            </div>
          </div>

          {/* Savings */}
          <div className="bg-transparent p-10">
            <div className="w-12 h-12 flex items-center justify-center bg-[#d3b366]/10 rounded-lg mb-6">
              <i className="ri-funds-line text-[#d3b366] text-2xl" />
            </div>
            <h3
              className="text-white text-xl font-medium mb-3"
              style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
            >
              Guaranteed Savings Analysis
            </h3>
            <p
              className="text-white/50 text-[15px] leading-relaxed mb-6"
              style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
            >
              Before you sign anything, we audit your current statements and show you exactly how much you are overpaying. If we cannot save you money, we tell you upfront.
            </p>
            <div className="border-t border-white/10 pt-6">
              <p
                className="text-[#d3b366] text-3xl font-light mb-1"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                15–30%
              </p>
              <p
                className="text-white/35 text-[10px] uppercase tracking-[0.15em]"
                style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
              >
                Avg. Overpayment Recovered
              </p>
            </div>
          </div>
        </div>

        {/* Bottom note */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 border-t border-white/10 pt-10">
          <p
            className="text-white/40 text-[15px] max-w-xl"
            style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
          >
            No setup fees. No cancellation fees. No long-term contracts. Month-to-month with full transparency from day one.
          </p>
          <a
            href="/contact"
            className="whitespace-nowrap inline-flex items-center gap-3 text-[12px] uppercase tracking-[0.18em] font-semibold text-[#d3b366] hover:text-white transition-colors duration-200 cursor-pointer"
            style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
          >
            Get Your Free Analysis
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}
